import React from 'react';
import type { ThemePalette } from '../../theme/tokens';

export interface ChanceyCardProps {
  children: React.ReactNode;
  c: ThemePalette;
  style?: React.CSSProperties;
  pad?: number;
  onClick?: () => void;
  className?: string;
}

export const ChanceyCard: React.FC<ChanceyCardProps> = ({
  children,
  c,
  style = {},
  pad = 16,
  onClick,
  className = '',
}) => (
  <div
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
    className={`rounded-card border ${className}`}
    style={{
      background: c.surface,
      borderRadius: 20,
      padding: pad,
      border: `0.5px solid ${c.line}`,
      ...style,
    }}
  >
    {children}
  </div>
);
